import * as React from "react";
import "./UserProfilePage.css";
import { useAuth } from "../../hooks/useAuth";
import Text from "../../components/Text/Text";
import Flex from "../../components/Flex/Flex";
import ChangeEmailForm from "../../components/ChangeEmailForm/ChangeEmailForm";
import ChangePasswordForm from "../../components/ChangePasswordForm/ChangePasswordForm";
import SupportForm from "../../components/SupportForm/SupportForm";
import { useTranslation } from "react-i18next";

const UserProfilePage = React.memo(() => {
  const { t } = useTranslation("translation");
  const { user } = useAuth();

  if (!user) {
    return null;
  }

  return (
    <Flex
      className="UserProfilePage"
      vertical
      gap={16}
    >
      <Text
        size={6}
        bold
      >
        {t("profile")}
      </Text>

      <div>
        <ChangeEmailForm email={user.email} />
        <ChangePasswordForm />
      </div>
      <SupportForm />
    </Flex>
  );
});

export default UserProfilePage;
